module.exports = __webpack_public_path__ + "static/img09-84f7196a1460cc81505ce98cfcbda975.jpg";